import React, { useEffect, useRef } from 'react';

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import Button from 'components/Button';

const ExclamationCircle = require('assets/resources/ExclamationCircle.svg').default;

const Modal = () => {
  const modalRef = useRef(null);
  const { isOpen, title, message, onConfirm, onCancel, confirmText, cancelText, type, classWrapModal } = useSelector((state) => state.common.modal);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('h-screen');
    } else {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('h-screen');
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const clickBackdrop = () => {
    modalRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  return ReactDOM.createPortal(
    <div data-testid="modal" id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-max">
      <div id="backdrop-modal" onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <div ref={modalRef} className={`bg-white rounded-sm shadow-lg p-8 pb-6 relative max-w-104 w-full modal-content ${classWrapModal}`}>
        <div data-testid="header-modal" id="header-modal" className="flex items-start">
          <div className="text-orange-500 mr-2 text-2xl min-w-6 min-h-6">
            <img src={ExclamationCircle} alt="exclamation" width={22} height={22} />
          </div>
          <h2 className="text-base font-bold text-logo" dangerouslySetInnerHTML={{ __html: title }} />
        </div>

        <p data-testid="message-modal" className="mt-6 text-gray-700">
          {message}
        </p>

        <div data-testid="footer-modal" id="footer-modal" className="mt-6 flex justify-end gap-2">
          {cancelText && <Button onClick={onCancel} text={cancelText} color="outline" className="w-25.5 px-3.75 h-8 text-sm text-black/85" />}
          {confirmText && (
            <Button
              onClick={onConfirm}
              text={confirmText}
              color={type === 'confirm' ? 'primary' : 'danger'}
              className={`${type === 'confirm' ? 'w-25.5 h-8' : 'w-14.5 h-7.5'} px-3.75  text-sm border border-solid ${type === 'confirm' ? 'border-primary-423' : ''}`}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default React.memo(Modal);
